export default __webpack_public_path__ + "static/media/image_2.16140700.png";